<template>
  <div class="detail">
    <div class="body">
      <!-- 导航栏 -->
      <div style="width:1440px;margin:0 auto;">
        <div v-if="width >= 1200" class="nav">
        心闻资讯 <i class="el-icon-arrow-right"></i> {{
          type == 1 ? '参观指导' : type == 2 ? '前沿动态' : type == 3 ? '学术交流' : type == 4 ? '实践在线' : '信息发布'
        }} <i class="el-icon-arrow-right"></i> <span style="color:#3DCDD0;font-size: 24px">详情</span>
      </div>
      <div v-if="width >= 1200" class="ql-container ql-snow">
        <div class="title" style="text-align: center">{{ title }}</div>
        <div class="small" style="text-align: center">瑞阳心语 {{ createTime.substr(0, 10) }}</div>
        <div class=" ql-editor ql-container ql-snow" style=" width: 1440px;margin: 50px auto;">
          <div v-html="content"></div>
        </div>
      </div>
      </div>
      <div v-if="width <= 768" style="padding:15px; box-sizing: border-box;" class="ql-container ql-snow">
        <div class="title">{{ title }}</div>
        <div class="small">瑞阳心语 {{ createTime.substr(0, 10) }}</div>
        <div class=" ql-editor ql-container ql-snow" style=" width: 1440px;margin: 50px auto;">
          <div v-html="content"></div>
        </div>
      </div>
      <!-- <div class="bigimg">
          <div class="imgs" v-for="(item,index) in imglist" :key="index">
          <img :src="item.url" alt="">
      </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import {getArticle} from '../api/api'

export default {
    data () {
        return {
            imglist:[
            ],
            id:"",
            content:"",
            title:"",
            createTime:"",
            type:"",
            width:document.documentElement.clientWidth
        }
    },
    mounted () {
        window.onresize = () => {
       return (() => {
         this.width = document.documentElement.clientWidth // 宽
       })
     }
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        getArticle(this.id).then(res => {
           if(res.data){
             this.content = res.data.data.content
             this.title = res.data.data.title
             this.createTime = res.data.data.createTime
           } else {
           }
        })
    }
}
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
  .detail {
    width: 100%;
    height: 100%;
  }
  .body {
    width: 100%;
    box-sizing: border-box;
    // padding: 100px 150px 0 150px;

    .nav {
      width: 100%;
      box-sizing: border-box;
      padding: 30px 0;
      font-size: 24px;
      color: #909090;
    }

    .title {
      font-size: 30px;
      color: #000000;
    }

    .small {
      font-size: 24px;
      color: #000000;
      margin: 40px 0;
    }

    P {
      font-size: 24px;
      color: #000000;
    }

    .bigimg {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 50px;
    }

    .imgs {
      width: 50%;
      height: 50vh;
      margin-top: 50px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media (max-width: 1200px) {
  .title {
    margin-top: 50px;
    font-size: 18px;
    color: #000000;
  }
  .small {
    font-size: 12px;
    color: #000000;
    margin: 20px 0;
  }
  P {
    font-size: 12px;
    color: #000000;
  }
  ::v-deep .content {
    p {
      img {
        width: 100% !important;
        height: 200px !important;
      }
    }

  }
}

</style>
